import React, { useState } from 'react';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const LanguageSelector = ({ currentLanguage, languagesList, changeLanguages, size }) => {
    localStorage.setItem('I18N_LANGUAGE', currentLanguage);
    const { i18n } = useTranslation();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const changeValue = (e, element) => {
        // dispatch(updateLanguage(element));
        changeLanguages(element);
        const selectedLanguage = element;
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem('I18N_LANGUAGE', selectedLanguage);
    };

    if (languagesList?.length > 0) {
        return (
            <Dropdown className="selectStyles" isOpen={dropdownOpen} toggle={toggle} size={size ? size : null}>
                <DropdownToggle tag="span" className="custom-toggle">
                    <i className="ri-arrow-drop-down-line mr-2"></i>
                    {currentLanguage}
                </DropdownToggle>
                <DropdownMenu>
                    {languagesList.map((element, index) => (
                        <React.Fragment key={index}>
                            {element.optionHeader && <DropdownItem header>{element.optionHeader}</DropdownItem>}
                            <DropdownItem
                                disabled={element.optionDisabled}
                                id={element}
                                key={index}
                                onClick={(e) => changeValue(e, element)}
                            >
                                {element}
                            </DropdownItem>
                        </React.Fragment>
                    ))}
                </DropdownMenu>
            </Dropdown>
        );
    } else {
        return null;
    }
};

export default LanguageSelector;
